namespace GeniuzPOS.CustomReport {
    export class ReportCusPromotionSaleColumns {
        static columnsKey = 'CustomReport.ReportCusPromotionSale';
    }
}
